import { createLead, getLeads } from 'lib/api';
import { LEADS_ACTIONS, LeadQueryParams, CreateParams, LeadItem } from '.';

const {
  GET_LEADS_START,
  GET_LEADS_ERROR,
  GET_LEADS_SUCCESS,
  ADD_LEAD_START,
  ADD_LEAD_ERROR,
  ADD_LEAD_SUCCESS,
} = LEADS_ACTIONS;

export const loadLeads = async ({
  size,
  page,
  search,
  dispatch,
}: LeadQueryParams): Promise<void> => {
  dispatch({ type: GET_LEADS_START });

  const response = await getLeads({
    start: page,
    limit: size,
    search: search,
  }).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_LEADS_ERROR,
      error: response.message,
    });
    return;
  }
  dispatch({
    type: GET_LEADS_SUCCESS,
    payload: {
      leads: response.leads,
      count: response.count,
    },
  });
};

export const addLead = async ({
  data,
  dispatch,
}: CreateParams): Promise<LeadItem | undefined> => {
  dispatch({ type: ADD_LEAD_START });

  const lead: LeadItem = await createLead(data).catch(err => err);

  if (lead instanceof Error) {
    dispatch({
      type: ADD_LEAD_ERROR,
      error: lead.message,
    });
    return;
  }

  dispatch({
    type: ADD_LEAD_SUCCESS,
    payload: {
      lead,
    },
  });

  return lead;
};
